import { motion } from "framer-motion";
import { BellRing } from "lucide-react";
import { WAITLIST } from "@/constants/testIds/waitlist";

export const SuccessPanel = ({ name }) => (
  <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
    className="max-w-md border border-border bg-white/70 backdrop-blur-md rounded-lg p-8" data-testid={WAITLIST.success}>
    <p className="text-sm tracking-[0.2em] uppercase text-accent mb-3">You're on the list</p>
    <h2 className="font-display text-4xl leading-tight mb-4">
      Thank you, <span className="italic text-primary" data-testid={WAITLIST.successName}>{name}</span>.
    </h2>
    <p className="text-muted-foreground leading-relaxed mb-6">Your place on the waitlist is saved.</p>
    <p className="flex gap-3 text-sm"><BellRing className="h-5 w-5 text-primary shrink-0" /> We'll be in touch on the contact details you gave us when enrolment opens.</p>
  </motion.div>
);
